import { createFileRoute } from "@tanstack/react-router";
import { prefetchUsageIfReadable } from "@/app/billing/usage-card-access";
import { Dashboard } from "@/app/dashboard/dashboard";
import { oauthProvidersCountQueryOptions } from "@/app/oauth/api/get-o-auth-providers-count";
import { secretsCountQueryOptions } from "@/app/secrets/api/get-secrets-count";
import { serversCountQueryOptions } from "@/app/servers/api/get-servers-count";
import { toolkitCollectionQueryOptions } from "@/app/tools/api/get-toolkit-collection";
import { toolsQueryOptions } from "@/app/tools/api/get-tools";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/home"
)({
  component: Dashboard,
  beforeLoad(ctx) {
    const { queryClient } = ctx.context;

    queryClient.prefetchQuery(
      toolsQueryOptions({ binding: "project", scope: ctx.params })
    );
    queryClient.prefetchQuery(toolkitCollectionQueryOptions(ctx.params));
    queryClient.prefetchQuery(
      oauthProvidersCountQueryOptions({ scope: ctx.params })
    );
    queryClient.prefetchQuery(serversCountQueryOptions({ scope: ctx.params }));
    queryClient.prefetchQuery(secretsCountQueryOptions({ scope: ctx.params }));
    prefetchUsageIfReadable(queryClient, ctx.params);
  },
  loader: () => ({
    crumb: "Dashboard",
  }),
});
